import { apiClient } from "./api";

export default {
	GetAllCountries() {
		return apiClient.get(`Authorize/countries`);
	},
};
